import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { change, Field, reduxForm, reset } from 'redux-form';
import { renderAutoCompleteMultipleSelection, renderCheckBox, renderDateField, renderTextField, renderAutoCompleteSingleSelect } from '../../../../components/reduxFields';
import RaisedButton from 'material-ui/RaisedButton';
import PaginatorCustom from '../../../../components/paginationCustom';
import { getClaimMasterData, getPatient, getOAandPayerResponseClaims, updateClaimServiceLineDetails, updateClaimServiceLineModifier } from './actions/ManageClaimActions';
import { resetFiltersAndSorting, showFormatedDate, showNormalizedRate } from '../../../../actions/utilAction';
import SortingCustom from '../../../../components/SortingCustom';
import moment from 'moment';
import ClaimInternalNotesModal from './ClaimInternalNotes_Modal';
import AddNoteModal from './AddNoteModal';
import CliamHistoryModal from './CliamHistoryModal';
import BatchResubmitClaimModal from './BatchResubmitClaim_Modal';

const stylescss = {
  checkbox: {
    marginBottom: 16,
  },
};
class OAandPayerResponse extends Component {

  constructor(props) {
    super(props);

    this.state = {
      claimId: null,
      patientName: null,
      payerName: null,
      claimIdArray: [],
      PatientId: null,
      PatientIds: null,
      ServiceCodes: null,
      RenderingProviderIds: null,            
      openBatchResubmitClaimModal: false,
      FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: new Date(),      
      selectedEDIClaimIds: [],            
      openInternalNotesModal: false,
      isAddNoteModalOpen: false,
      openClaimHistoryModal: false,
      masterTags: [],
      isExcludeTag: [],
      IsSearchForSingleClaim: false,
      selectedEDIClaimsPayerControlNumber: [],
      selectedEDIClaimsSecondaryPayerControlNumber: [],
      locationId: 0,
      ClickedOn : '',
      ServiceLocationTypeIds: null,
      ClaimOfficeallyStatusIds: null,
    };

    this.filter = {
      sort_Column: 'claimId',
      sort_Order: 'desc',
    };

    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleSearchProcessedClaim = this.handleSearchProcessedClaim.bind(this);
    this.handleClaimIDCheck = this.handleClaimIDCheck.bind(this);
    this.checkAllClaimId = this.checkAllClaimId.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.CheckClaim = this.CheckClaim.bind(this);
    this.handleNewRequestMultiSelect = this.handleNewRequestMultiSelect.bind(this);
    this.handleEditAlternateServiceCode = this.handleEditAlternateServiceCode.bind(this);
    this.handleEditAlternateModifier = this.handleEditAlternateModifier.bind(this);
  }

  loadData(page_number) {
       
    let searchObj = {
      sort_fields: this.filter.sort_Column ? this.filter.sort_Column : 'claimId',
      sort_order: this.filter.sort_Order ? this.filter.sort_Order : 'desc',
      contain_filters: {
        claimId: this.state.ClaimId && this.state.IsSearchForSingleClaim ? (Number.isInteger(this.state.ClaimId) ? 'CL' + this.state.ClaimId.toString().trim() : this.state.ClaimId.trim()) : null,
        patientIds: this.state.PatientIds ? this.state.PatientIds : '',        
        payerName: this.state.payerName ? this.state.payerName : '',
        fromDate: this.state.FromDate ? moment(this.state.FromDate).format('YYYY-MM-DD') : new Date().setDate(new Date().getDate() - 7),
        toDate: this.state.ToDate ? moment(this.state.ToDate).format('YYYY-MM-DD') : new Date(),
        claimStatusId: 1,        
        serviceCode: this.state.ServiceCodes ? this.state.ServiceCodes : '',
        tagIds: this.state.masterTags,
        isExcludeTag: this.state.isExcludeTag,        
        renderingProviderIds: this.state.RenderingProviderIds ? this.state.RenderingProviderIds : '',
        locationId: this.state.locationId ? this.state.locationId : 0,
        serviceLocationTypeIds: this.state.ServiceLocationTypeIds ? this.state.ServiceLocationTypeIds : '',
        //claimOfficeallyStatusIds: this.state.ClaimOfficeallyStatusIds ? this.state.ClaimOfficeallyStatusIds : '',
        claimOfficeallyStatusIds: this.state.ClaimOfficeallyStatusIds ? this.state.ClaimOfficeallyStatusIds : '',
      },
      pageNumber: page_number ? page_number : 1,
      pageSize: 50,
    };
     //console.log('searchObj........',searchObj)
    this.props.getOAandPayerResponseClaims(searchObj);

  }


  componentWillMount() {

    let searchObj = {
      // locationIds: this.props.currentLocationId || '',
      locationIds: '0',
      isActiveCheckRequired: 'NO',
      isActiveClientsOnly : this.props.isChecked,
    };
    this.props.getPatient(searchObj);
    this.loadData();

    let masterData = { 'masterdata': 'masterInsuranceCompany,MASTERSERVICECODE,MASTERTAGSFORALL,MASTERRENDERINGPROVIDERINCLUDINGINACTIVE,MASTERLOCATION,MASTERPATIENTLOCATION,CLAIMOFFICEALLYSTATUS' };
    this.props.getClaimMasterData(masterData);
  }

  componentWillReceiveProps(nextProps) {  
    if (nextProps.edi837ForSecondary && nextProps.edi837ForSecondary !== this.props.edi837ForSecondary) {
      this.setState({ selectedEDIClaimIds: [], selectedEDIClaimsPayerControlNumber: [], selectedEDIClaimsSecondaryPayerControlNumber: []});
      this.ResetAllClaims();
      this.loadData();
    }

    if (nextProps.resubmitBatchClaim && nextProps.resubmitBatchClaim !== this.props.resubmitBatchClaim) {
      this.setState({ selectedEDIClaimIds: [], selectedEDIClaimsPayerControlNumber: [], selectedEDIClaimsSecondaryPayerControlNumber: []});
      this.ResetAllClaims();
      this.loadData();
    }
  }

  handleOpenInternalNotes = (event, obj) => {
    // console.log('event, claimId.........', obj)
    this.setState({ openInternalNotesModal: true, ClaimId: obj.claimId });    
  };
    
  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_Order = col_order;

      this.loadData();
    }
  }
  handleNewRequestMultiSelect(input, selectedValues) {    
    input.onChange(selectedValues);
    if (input.name === 'PatientIds') {
      this.setState({
        PatientIds: selectedValues,
      });
    } 
    else if(input.name === 'MasterServiceCode')
    {      
      this.setState({
        ServiceCodes: selectedValues,
      });
    }
    else if(input.name === 'RenderingProviderIds')
    {
      this.setState({
        RenderingProviderIds: selectedValues,
      });
    }
    else if(input.name === 'ServiceLocationTypeIds')
    {      
      this.setState({
        ServiceLocationTypeIds: selectedValues,
      });
    }
    else if(input.name === 'ClaimOfficeallyStatus')
    {      
      this.setState({
        ClaimOfficeallyStatusIds: selectedValues,
      });
    }
  }

  handleChangePatientInsurance = (input, selected) => {
    input.onChange(selected.value);
    this.setState({ payerName: selected.label })
  }

  handleSearchProcessedClaim(event) {
    // event.preventDefault();
    // console.log('event............',event);
    this.setState({
      ClaimId: event.claimId ? event.claimId : null,
      IsSearchForSingleClaim: event.claimId ? true : false,
      PatientIds: this.state.PatientIds ? this.state.PatientIds : '',      
      PayerName: event.InsuranceCompany ? event.InsuranceCompany : '',
      FromDate: event.FromDate ? showFormatedDate(event.FromDate) : new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: event.ToDate ? showFormatedDate(event.ToDate) : new Date(),      
      serviceCode: this.state.ServiceCodes ? this.state.ServiceCodes : '',      
      // PayerName: event.InsuranceCompany ? event.InsuranceCompany : '',
    }, () => {
      this.loadData();
    });
    // console.log('event............',event);
  }

  CheckClaim(e, index, claimId, secondaryPayerClaimControlNumber, payerClaimControlNumber) {
    let selectedEDIClaimIds = this.state.selectedEDIClaimIds;
    let selectedEDIClaimsPayerControlNumber = this.state.selectedEDIClaimsPayerControlNumber;
    let selectedEDIClaimsSecondaryPayerControlNumber = this.state.selectedEDIClaimsSecondaryPayerControlNumber;
    let isClaimChecked = e.target.checked;
    if (isClaimChecked) {
      selectedEDIClaimIds.push(claimId);      
      selectedEDIClaimsPayerControlNumber.push(payerClaimControlNumber);
      selectedEDIClaimsSecondaryPayerControlNumber.push(secondaryPayerClaimControlNumber);
    } else {
      index = selectedEDIClaimIds.findIndex((value) => value === claimId);
      if (index >= 0) {
        selectedEDIClaimIds.splice(index, 1);
      }

      index = selectedEDIClaimsSecondaryPayerControlNumber.findIndex((value) => value === secondaryPayerClaimControlNumber);
      if (index >= 0) {
        selectedEDIClaimsSecondaryPayerControlNumber.splice(index, 1);
      }

      index = selectedEDIClaimsPayerControlNumber.findIndex((value) => value === payerClaimControlNumber);
      if (index >= 0) {
        selectedEDIClaimsPayerControlNumber.splice(index, 1);
      }

    }

    this.setState({ selectedEDIClaimIds, selectedEDIClaimsPayerControlNumber, selectedEDIClaimsSecondaryPayerControlNumber });
  }
  
  updateAlternateServiceCode = (e, claimId, claimServiceLineId) => {
    var editableText = (e.target.value || '').trim();
    let postData = {};
    if (editableText) {
      this.setState({
        editClaimServiceLineId: 0,
      });
      postData = {
        claimId: claimId,
        id: claimServiceLineId,
        alternateServiceCode: editableText,
      };
    }
    else{
      postData = {
        claimId: claimId,
        id: claimServiceLineId,
        alternateServiceCode: null,
      };
    }
    // console.log('postData values to send...', JSON.stringify(postData));
    let alternateServiceCode = `ClaimServiceLine[${claimServiceLineId}].alternateServiceCode`;
    this.props.dispatch(change('OAandPayerResponseForm', alternateServiceCode, editableText));

    this.props.updateClaimServiceLineDetails(postData);
    // this.loadData();
  }

  handleEditAlternateServiceCode(e, claimServiceLineId, editableText) {
    this.setState({
      editClaimServiceLineId: claimServiceLineId,
      ClickedOn: 'servicecode'
    },()=>{
      let alternateServiceCode = `ClaimServiceLine[${claimServiceLineId}].alternateServiceCode`;
      this.props.dispatch(change('OAandPayerResponseForm', alternateServiceCode, editableText));
    });
  }

  updateAlternateModifier = (e, claimId, claimServiceLineId, label) => {
    var editableText = (e.target.value || '').trim();
    let postData = {};

    if(label === 'modifier1') {
      if (editableText) {
        this.setState({
          editClaimServiceLineId: 0,
        });
        postData = {
          claimId: claimId,
          id: claimServiceLineId,
          modifier1: editableText,
        };
      }
      else{
        postData = {
          claimId: claimId,
          id: claimServiceLineId,
          modifier1: null,
        };
      }
    }
    else if(label === 'modifier2') {
      if (editableText) {
        this.setState({
          editClaimServiceLineId: 0,
        });
        postData = {
          claimId: claimId,
          id: claimServiceLineId,
          modifier2: editableText,
        };
      }
      else{
        postData = {
          claimId: claimId,
          id: claimServiceLineId,
          modifier2: null,
        };
      }
    }
    else if(label === 'modifier3') {
      if (editableText) {
        this.setState({
          editClaimServiceLineId: 0,
        });
        postData = {
          claimId: claimId,
          id: claimServiceLineId,
          modifier3: editableText,
        };
      }
      else{
        postData = {
          claimId: claimId,
          id: claimServiceLineId,
          modifier3: null,
        };
      }
    }
    else if(label === 'modifier4') {
      if (editableText) {
        this.setState({
          editClaimServiceLineId: 0,
        });
        postData = {
          claimId: claimId,
          id: claimServiceLineId,
          modifier4: editableText,
        };
      }
      else{
        postData = {
          claimId: claimId,
          id: claimServiceLineId,
          modifier4: null,
        };
      }
    }
    // console.log('postData values to send...', JSON.stringify(postData));
    let alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier1`;
      
    if(label === 'modifier1')   
        alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier1`;
    else if(label === 'modifier2')   
        alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier2`;
    else if(label === 'modifier3')   
        alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier3`;
    else if(label === 'modifier4')   
        alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier4`;   

    this.props.dispatch(change('OAandPayerResponseForm', alternateModifier, editableText));

    this.props.updateClaimServiceLineModifier(postData, label);
    // this.loadData();
  }

  handleEditAlternateModifier(e, claimServiceLineId, editableText, label) {    
    this.setState({
      editClaimServiceLineId: claimServiceLineId,
      ClickedOn: label
    },()=>{      
      let alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier1`;
      
      if(label === 'modifier1')   
         alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier1`;
      else if(label === 'modifier2')   
         alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier2`;
      else if(label === 'modifier3')   
         alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier3`;
      else if(label === 'modifier4')   
         alternateModifier = `ClaimServiceLine[${claimServiceLineId}].modifier4`;   

        this.props.dispatch(change('OAandPayerResponseForm', alternateModifier, editableText));
    });
  }


  handleOnSubmit = (event, obj) => {
    // console.log('obj.............',obj);
    // console.log('obj.............', Obj);
    return this.setState({  ClaimId: obj.claimId, PatientId: obj.patientId, organizationID: this.props.loginUserInfo.organizationID });    
  }
  

  
  handleBatchEDIGeneration = (event) => {

    this.setState({ openBatchResubmitClaimModal: true });
    // Alert.warning('Are you sure you want to re-submit selected claims for EDI generation?', {
    //   position: 'bottom-right',
    //   effect: 'slide',
    //   timeout: 10000,
    //   customFields: {
    //     displayComponent: true,
    //     handleButtonClick: this.handleAlertBatchEDIGenerationClick,
    //     //id: obj.id,
    //   },
    // });
  }

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }
  handleClose = () => {
    this.setState({ openBatchResubmitClaimModal : false, openInternalNotesModal: false, isAddNoteModalOpen: false, selectedEDIClaimIds:[], selectedEDIClaimsPayerControlNumber: [], selectedEDIClaimsSecondaryPayerControlNumber : [] }, () => this.handleReset());
  };

  closeDialog = () => {
    this.setState({ openBatchResubmitClaimModal : false, openInternalNotesModal: false, isAddNoteModalOpen: false, selectedEDIClaimIds:[], selectedEDIClaimsPayerControlNumber: [], selectedEDIClaimsSecondaryPayerControlNumber : [] },()=>this.props.dispatch(reset('OAandPayerResponseForm', 'chk', null)));
  };

  ResetAllClaims() {
    this.props.dispatch(change('OAandPayerResponseForm', 'chk', false));    
    this.props.oaandpayerResponseClaim.data.OAProcessedClaims.map((Obj, index) => {
      let claimIdCheck = `Check${Obj.claimId}`;      
      this.props.dispatch(change('OAandPayerResponseForm', claimIdCheck, false));
    });
  }
  
  handleCloseWithoutReset = () => {    
    this.ResetAllClaims();
    this.setState({  openBatchResubmitClaimModal : false, openInternalNotesModal: false, isAddNoteModalOpen: false, selectedEDIClaimIds:[], selectedEDIClaimsPayerControlNumber: [], selectedEDIClaimsSecondaryPayerControlNumber : [] });
  }

  handleClaimIDCheck = (input) => {
    // console.log('input.target.name......', input.target.value);
    // console.log('input.target.checked......', input.target.checked);
    let inputName = input.target.value;
    let inputvalue = inputName.replace('Check', '');
    // console.log('inputvalue......', inputvalue);
    let value = parseInt(inputvalue, 10);
    if (input.target.checked) {
      let claimArray = this.state.claimIdArray,
        id = Number.isInteger(value) ? value : null;
      claimArray.push(id);
      this.setState({
        claimIdArray: claimArray || null,
      });
      // console.log('this.state.claimIdArray................', this.state.claimIdArray);
    } else {
      let claimArray = this.state.claimIdArray,
        index = claimArray.indexOf(value);
      if (index >= 0) {
        claimArray = claimArray.splice(index, 1);
        this.setState({
          claimIdArray: claimArray || null,
        });
        // console.log('this.state.claimIdArray................', this.state.claimIdArray);

      }
    }
  }
  handleReset = () => {
    this.props.dispatch(reset('OAandPayerResponseForm'));
    resetFiltersAndSorting(this.filter, 'claimId', true);
    this.setState({
      openInternalNotesModal: false,
      ClaimId: null,
      PatientIds: null,            
      PayerName: null,
      FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: new Date(),
      claimIdArray: [],
      masterTags: [],
      isExcludeTag: [],      
      RenderingProviderIds: null,
      locationId: 0,
      ServiceLocationTypeIds: null,
      ClaimOfficeallyStatusIds: null,
    }, () => {
      this.loadData();
    });
  };
  handleExpandRow = (claimId,responseId) => {
    this.setState({ ClaimId: claimId });
    let display = this.refs['expandedClass' + claimId+''+responseId].style.display;
    if (display === 'none') {
      this.refs['expandedClass' + claimId+''+responseId].style.display = 'table-row';
      this.refs['expClass' + claimId+''+responseId].className = 'classExpand fa fa-minus';
    } else {
      this.refs['expandedClass' + claimId+''+responseId].style.display = 'none';
      this.refs['expClass' + claimId+''+responseId].className = 'classExpand fa fa-ellipsis-h';
    }
  }
  checkAllClaimId(input, claimId) {
    // console.log('input.target.checked.........', e.target.checked);
    let selectedEDIClaimIds = [];
    let selectedEDIClaimsPayerControlNumber = [];
    let selectedEDIClaimsSecondaryPayerControlNumber = [];
    this.props.oaandpayerResponseClaim.data.OAProcessedClaims.map((Obj, index) => {
      let claimCheck = 'Check' + Obj.claimId;
      if (Obj && input.target.checked) {
        selectedEDIClaimIds.push(Obj.claimId);
        selectedEDIClaimsPayerControlNumber.push(Obj.payerClaimControlNumber);
        selectedEDIClaimsSecondaryPayerControlNumber.push(Obj.secondaryPayerClaimControlNumber);
        // console.log('actionCheck........', actionCheck);
        return this.props.dispatch(change('OAandPayerResponseForm', claimCheck, true));
      } else {
        // console.log('actionUnCheck........', actionCheck);
        return this.props.dispatch(change('OAandPayerResponseForm', claimCheck, false));
      }
    });
    this.setState({ selectedEDIClaimIds, selectedEDIClaimsPayerControlNumber, selectedEDIClaimsSecondaryPayerControlNumber });
  }


  handleExpandRowAdjustment = (claim837ClaimId) => {
    this.setState({ claim837ClaimId: claim837ClaimId });
    let display = this.refs['expandedClass' + claim837ClaimId].style.display;
    if (display === 'none') {
      this.refs['expandedClass' + claim837ClaimId].style.display = 'table-row';
      this.refs['expInnerClass' + claim837ClaimId].className = 'classExpand fa fa-minus';
    } else {
      this.refs['expandedClass' + claim837ClaimId].style.display = 'none';
      this.refs['expInnerClass' + claim837ClaimId].className = 'classExpand fa fa-ellipsis-h';
    }
  }

  renderInnerErrorData(claim837ClaimId, responseId) {
    let oAAndPayerClaimRejectedReason = this.props.oaandpayerResponseClaim.data.OAAndPayerClaimRejectedReason || [],
      filteredOAAndPayerClaimRejectedReasonInnerData = oAAndPayerClaimRejectedReason.filter((obj) => obj.claim837ClaimId === claim837ClaimId && obj.responseId === responseId);
    return filteredOAAndPayerClaimRejectedReasonInnerData.map((data, index) => {
      return (
        <tr key={index}>
          <td></td>      
          <td>{data.responseMessage}</td>          
        </tr>
      );
    });
  }
  
  handleOpenHistory = (event, claimId) => {
    this.setState({
      openClaimHistoryModal: true,
      ClaimId: claimId
    });
  }

  handleCloseClaimHistoryModal = () => {
    this.setState({
      openClaimHistoryModal: false
    });
  }

  
  handleAddBulkNoteClick = () => {
    this.setState({
      isAddNoteModalOpen: true
    })
  }

  handleNewRequest = (input, selectedValues) => {
    if (input.name === 'tags') {      
        input.onChange(selectedValues);
        this.setState({
          masterTags: selectedValues,
        }, () => this.state.masterTags.length === 0 ? this.props.dispatch(reset('OAandPayerResponseForm',"ExcludeTag", false)): '');
    }
    else if (input.name === 'locationId') {              
      this.setState({  locationId : selectedValues.value }, () => {input.onChange(selectedValues.value);});
    }    
  }

  
  isExcludeTagHandler = (e) => {
    this.setState({
      isExcludeTag: !this.state.isExcludeTag
    });
  }

  isActiveClientHandler = (e) =>{
    this.props.handleToggle();
  }

  handleCloseBatchEDIGeneration = () => {
    this.setState({ openBatchResubmitClaimModal : false, openInternalNotesModal: false, isAddNoteModalOpen: false, selectedEDIClaimIds:[], selectedEDIClaimsPayerControlNumber: [], selectedEDIClaimsSecondaryPayerControlNumber : [] },()=>{
      this.ResetAllClaims();
    });    
  }

  renderInnerData(claim837ClaimId, claimId, responseId) {
    const tableClass3 = classNames({
      'table': true,
      'childtable': true,
      'customtable': false,
    });
    // console.log('this.props.oaandpayerResponseClaim.......', this.props.oaandpayerResponseClaim);
    let processedClaimInnerData = this.props.oaandpayerResponseClaim.data.OAProcessedClaimServiceLines || [],
      filteredProcessedClaimInnerData = processedClaimInnerData.filter((obj) => obj.claim837ClaimId === claim837ClaimId);
    return filteredProcessedClaimInnerData.map((innerData, index) => {
      return (
        <tbody key={index}>
          <tr>        
            <th width="8%"></th>
            <td width="12%"> <div className="table_custom-check">
              <button onClick={(e) => this.handleExpandRowAdjustment(innerData.claim837ClaimId+''+innerData.claimId+''+responseId)} type="button" className="morebtn">
                <i ref={'expInnerClass' + innerData.claim837ClaimId+''+innerData.claimId+''+responseId} className="classExpand fa fa-ellipsis-h" aria-hidden="true"></i>
              </button>
            </div></td>
            <td width="15%">{innerData.serviceCode}</td>
            <td width="10%">{innerData.serviceLineDOS ? showFormatedDate(innerData.serviceLineDOS) : ''}</td>
            <td width="9%">
            {((this.state.editClaimServiceLineId === innerData.claimServicelineId || !innerData.alternateServiceCode) && (!innerData.alternateServiceCode || this.state.ClickedOn === 'servicecode')) ?
              (<Field
                name={`ClaimServiceLine[${innerData.claimServicelineId}].alternateServiceCode`}
                type="text"
                maxLength="80"
                value={innerData.alternateServiceCode}
                hintText={'Service Code'}
                onBlur={(e) => this.updateAlternateServiceCode(e, claimId, innerData.claimServicelineId)}
                component={renderTextField} />)
              : (
                <span onDoubleClick={(e) => this.handleEditAlternateServiceCode(e, innerData.claimServicelineId, innerData.alternateServiceCode)}>
                  {innerData.alternateServiceCode}
                </span>)}
          </td>
          <td width="9%">
            {((this.state.editClaimServiceLineId === innerData.claimServicelineId || !innerData.modifier1) && (!innerData.modifier1 || this.state.ClickedOn === 'modifier1')) ?
              (<Field
                name={`ClaimServiceLine[${innerData.claimServicelineId}].modifier1`}
                type="text"
                maxLength="80"
                value={innerData.modifier1}
                hintText={'Modifier 1'}
                onBlur={(e) => this.updateAlternateModifier(e, claimId, innerData.claimServicelineId, 'modifier1')}
                component={renderTextField} />)
              : (
                <span onDoubleClick={(e) => this.handleEditAlternateModifier(e, innerData.claimServicelineId, innerData.modifier1, 'modifier1')}>
                  {innerData.modifier1}
                </span>)}
          </td>
          <td width="9%">
            {((this.state.editClaimServiceLineId === innerData.claimServicelineId || !innerData.modifier2) && (!innerData.modifier2 || this.state.ClickedOn === 'modifier2')) ?
              (<Field
                name={`ClaimServiceLine[${innerData.claimServicelineId}].modifier2`}
                type="text"
                maxLength="80"
                value={innerData.modifier2}
                hintText={'Modifier 2'}
                onBlur={(e) => this.updateAlternateModifier(e, claimId, innerData.claimServicelineId, 'modifier2')}
                component={renderTextField} />)
              : (
                <span onDoubleClick={(e) => this.handleEditAlternateModifier(e, innerData.claimServicelineId, innerData.modifier2, 'modifier2')}>
                  {innerData.modifier2}
                </span>)}
          </td>
          <td width="9%">
            {((this.state.editClaimServiceLineId === innerData.claimServicelineId || !innerData.modifier3) && (!innerData.modifier3 || this.state.ClickedOn === 'modifier3')) ?
              (<Field
                name={`ClaimServiceLine[${innerData.claimServicelineId}].modifier3`}
                type="text"
                maxLength="80"
                value={innerData.modifier3}
                hintText={'Modifier 3'}
                onBlur={(e) => this.updateAlternateModifier(e, claimId, innerData.claimServicelineId, 'modifier3')}
                component={renderTextField} />)
              : (
                <span onDoubleClick={(e) => this.handleEditAlternateModifier(e, innerData.claimServicelineId, innerData.modifier3, 'modifier3')}>
                  {innerData.modifier3}
                </span>)}
          </td>
          <td width="9%">
            {((this.state.editClaimServiceLineId === innerData.claimServicelineId || !innerData.modifier4) && (!innerData.modifier4 || this.state.ClickedOn === 'modifier4')) ?
              (<Field
                name={`ClaimServiceLine[${innerData.claimServicelineId}].modifier4`}
                type="text"
                maxLength="80"
                value={innerData.modifier4}
                hintText={'Modifier 4'}
                onBlur={(e) => this.updateAlternateModifier(e, claimId, innerData.claimServicelineId, 'modifier4')}
                component={renderTextField} />)
              : (
                <span onDoubleClick={(e) => this.handleEditAlternateModifier(e, innerData.claimServicelineId, innerData.modifier4, 'modifier4')}>
                  {innerData.modifier4}
                </span>)}
          </td>
          <td width="10%">{innerData.serviceFacilityCode}</td>                   
          </tr>
          <tr className="nohover" ref={'expandedClass' + innerData.claim837ClaimId+''+innerData.claimId+''+responseId} style={{ 'display': 'none' }}>
            <td></td>
            <td colSpan="8">
              <table className={tableClass3}>
                <thead>
                  <tr>
                    <th width="15%"></th>                             
                    <th width="85%">OA Response</th>                    
                  </tr>
                </thead>
                <tbody>
                  {this.renderInnerErrorData(innerData.claim837ClaimId, responseId)}
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      );
    });
  };

  renderData() {
    const tableClass1 = classNames({
      'table': true,
      'middletable ': true,
      'customtable': true,
      'colorChange': true,
    });
    const tableClass2 = classNames({
      'table': true,
      'childtable': true,
    });
    return this.props.oaandpayerResponseClaim.data.OAProcessedClaims.map((Obj, index) => {
      // console.log('Obj.......',Obj );
      return (
        <tr key={index}>
          <td colSpan="10">
            <table className={tableClass1}>
              <tbody>
                <tr>
                  <td width="7%"> <div className="table_custom-check">
                    <Field
                      name={'Check' + Obj.claimId}                      
                      // onChange={this.handleClaimIDCheck}
                      disabled= {Obj.applied && Obj.applied === true ? false : false}
                      onChange={(e) => this.CheckClaim(e, index, Obj.claimId, Obj.secondaryPayerClaimControlNumber, Obj.payerClaimControlNumber)}
                      component={renderCheckBox}
                      style={stylescss.checkbox}
                    />
                    <button onClick={(e) => this.handleExpandRow(Obj.claimId, Obj.responseId)} type="button" className="morebtn">
                      <i ref={'expClass' + Obj.claimId+''+Obj.responseId} className="classExpand fa fa-minus" aria-hidden="true"></i>
                    </button>
                  </div></td>
                  <td width="13%">{'CL' + Obj.claimId}</td>
                  {/* <td width="10%">{showFormatedDate(Obj.dos)}</td> */}
                  <td width="15%">{Obj.patientName}</td>
                  <td width="15%">{Obj.payerName}</td>
                  <td width="9%">{showNormalizedRate(Obj.amountClaimed || 0)}</td>
                  <td width="9%">{Obj.submittedAs}</td>                  
                  <th width="15%">{Obj.claimOfficeallyStatus}</th>                                 
                  <td width="7%">
                    {/* <button onClick={(e) => this.handleOnSubmit(e, Obj)} type="button" title="Submit" className="tbactionbtn bluefont"><i className="fa fa-paper-plane" aria-hidden="true"></i></button> */}
                    <button onClick={(e) => this.handleOpenInternalNotes(e, Obj)} type="button" title="Claim Internal Notes" className="tbactionbtn bluefont"><i className="fa fa-sticky-note-o" aria-hidden="true"></i></button>
                    <button onClick={(e) => this.handleOpenHistory(e, Obj.claimId)} type="button" title="Claim History" className="tbactionbtn bluefont"><i className="fa fa-history" aria-hidden="true"></i></button>                    
                  </td>
                </tr>
                <tr className="nohover" ref={'expandedClass' + Obj.claimId+''+Obj.responseId} style={{ 'display': 'table-row' }}>
                  <td colSpan="9">
                    <table className={tableClass2}>
                      <thead>
                        <tr>        
                          <th width="8%"></th>                  
                          <th width="12%"></th>
                          <th width="15%">Service Code</th>
                          <th width="10%">DOS</th>
                          <th width="9%">Alt. Code</th>
                          <th width="9%">Modifier1</th>
                          <th width="9%">Modifier2</th>
                          <th width="9%">Modifier3</th>
                          <th width="9%">Modifier4</th>
                          <th width="10%">Loc. Code</th>  
                        </tr>
                      </thead>
                      {this.renderInnerData(Obj.claim837ClaimId, Obj.claimId, Obj.responseId)}
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      );
    });
  }

  render() {
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'maintable': true,
      'customtable': true,
    });
    // const tableClass1 = classNames({
    //   'table': true,
    //   'maintable': true,
    //   'customtable': true,
    // });
    return (
      <div>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchProcessedClaim)}>
              <div className="row mtm-20">
                <div className="col-sm-4">
                  <Field
                    autoFocus={true}
                    name="claimId"
                    floatingLabelText="Claim ID"
                    onChange={this.handleSearchChange}
                    component={renderTextField} />
                </div>
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="PatientIds"
                    label="Client Name"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.patientlist}
                    component={renderAutoCompleteMultipleSelection}/>
                </div>
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="MasterServiceCode"
                    label="Service Code"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.masterServiceCode}
                    component={renderAutoCompleteMultipleSelection} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <Field name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection = {true}
                    component={renderDateField} />
                </div>
                <div className="col-sm-4">
                  <Field name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    minDate = {this.state.FromDate}
                    selected={this.state.ToDate}
                    openToYearSelection = {true}
                    onDateChange={this.onDateChange}
                    component={renderDateField} />
                </div>
                <div className="col-sm-4 mt-35">
                  <Field
                    name="InsuranceCompany"
                    label="Insurance Company"
                    handleNewRequest={this.handleChangePatientInsurance}
                    options={this.props.masterInsurances}
                    component={renderAutoCompleteSingleSelect} />
                  {/* <Field name="InsuranceCompany"
                    floatingLabelText="Insurance Company"
                    maxLength="50"
                    onChange={this.handleSearchChange}
                    component={renderTextField} /> */}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3 insfield mt-35">
                  <Field
                    name="tags"
                    label="Tags"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.masterTagsForAll}
                    component={renderAutoCompleteMultipleSelection} />
                </div>                
                {this.state.masterTags.length > 0 ?
                  <div className="col-sm-3 insfield mt-35">
                  <Field
                      name="ExcludeTag"
                      label="Exclude Tag"
                      component={renderCheckBox}
                      onChange={(e) => this.isExcludeTagHandler(e)}
                      style={stylescss.checkbox}
                    />
                  </div>              
                :null}    
                 <div className="col-sm-3 insfield mt-35">
                    <Field
                      name="ClaimOfficeallyStatus"
                      label="Claim Clearinghouse Status"
                      handleNewRequest={this.handleNewRequestMultiSelect}
                      options={this.props.masterClaimOfficeallyStatus}
                      component={renderAutoCompleteMultipleSelection}
                    />
                  </div>
              </div>                 
              <div className="row"> 
                <div className="col-sm-4 insfield mt-35">
                    <Field
                      name="RenderingProviderIds"
                      label="Rendering Provider"
                      handleNewRequest={this.handleNewRequestMultiSelect}
                      options={this.props.masterRenderingProviderIncludingInactive}
                      component={renderAutoCompleteMultipleSelection} />
                </div>
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="locationId"
                    label="Location (Office Location of Session)"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.masterLocation}
                    component={renderAutoCompleteSingleSelect} />
                </div>
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="ServiceLocationTypeIds"
                    label="Service Location Type"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.masterPatientLocation}
                    component={renderAutoCompleteMultipleSelection} />
                </div>                
              </div>              
              <div className="row">         
                <div className="col-10 col-sm-10 col-md-10 reset-btn claims_btn">                
                  <RaisedButton className={this.state.selectedEDIClaimIds.length > 0 ? 'grey_btn' : 'grey_btn reset-disable'} disabled={this.state.selectedEDIClaimIds.length > 0 ? false : true} onTouchTap={(e) => this.handleBatchEDIGeneration(e)} >Batch EDI Generation For Primary Payer</RaisedButton>                                                                      
                  <RaisedButton className={this.state.selectedEDIClaimIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} disabled={this.state.selectedEDIClaimIds.length > 0 ? false : true} onTouchTap={(e) => this.handleAddBulkNoteClick(e)} >Add Bulk Note</RaisedButton>                  
                </div>
                <div className="col-2 col-sm-2 col-md-2 btn_rt reset-btn claims_filter">
                  <RaisedButton className="grey_btn" type="Submit" primary={true} >Filter</RaisedButton>
                  <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                </div>
              </div>
            </form>
            
            {this.state.openInternalNotesModal ? <ClaimInternalNotesModal claimId={this.state.ClaimId} closeDialog={this.handleCloseWithoutReset} /> : null}

            {this.state.isAddNoteModalOpen ? <AddNoteModal ClaimId={this.state.ClaimId} PatientId={this.state.PatientId} OrganizationId={this.state.organizationID} closeDialog={this.handleCloseWithoutReset} claimIds={this.state.selectedEDIClaimIds}/> : null}

            {this.state.openClaimHistoryModal ? <CliamHistoryModal claimHistoryId={this.state.ClaimId}  PatientId={this.state.PatientId}  closeDialog={() => this.handleCloseClaimHistoryModal()}/> : null}

            {this.state.openBatchResubmitClaimModal && <BatchResubmitClaimModal isDownloadEDI = {false} selectedBatchClaimArray={this.state.selectedEDIClaimIds} selectedEDIClaimsPayerControlNumber={this.state.selectedEDIClaimsPayerControlNumber} closeDialog={this.handleClose} />}
           
            <div className="row">
              <div className="col-sm-12">
                <div className="table-responsive mt-20">
                  {this.props.oaandpayerResponseClaim.data && this.props.oaandpayerResponseClaim.data.OAProcessedClaims && this.props.oaandpayerResponseClaim.data.OAProcessedClaims.length ?
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="7%"><div className="table_custom-check">
                            <Field
                              name= 'chk'
                              // onChange={this.handleClaimIDCheck}
                              component={renderCheckBox}
                              onChange={(input) => this.checkAllClaimId(input, this.props.oaandpayerResponseClaim.data.OAProcessedClaims.claimId)}
                              style={stylescss.checkbox}
                            />
                          </div></th>
                          <th width="13%"><SortingCustom setSortColumn={this.setSortColumn} columnName='claimId' displayName='Claim ID' /></th>
                          {/* <th width="10%"><SortingCustom setSortColumn={this.setSortColumn} columnName='dos' displayName='DOS' /></th>                           */}
                          <th width="15%"><SortingCustom setSortColumn={this.setSortColumn} columnName='patientName' displayName='Client' /></th>
                          <th width="15%"><SortingCustom setSortColumn={this.setSortColumn} columnName='payerName' displayName='Payer' /></th>
                          <th width="9%"><SortingCustom setSortColumn={this.setSortColumn} columnName='amountClaimed' displayName='Claim Amt.' /></th>                          
                          <th width="9%">Submitted To</th>
                          <th width="15%">Clearinghouse Status</th>                                                    
                          <th width="7%">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.renderData()}
                      </tbody>
                    </table>
                    :
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="7%"><span>&nbsp;</span></th>
                          <th width="13%"><span>Claim ID</span></th>
                          {/* <th width="10%"><span>DOS</span></th> */}
                          <th width="15%"><span>Client</span></th>
                          <th width="15%"><span>Payer</span></th>
                          <th width="9%"><span>Claim Amt.</span></th>                          
                          <th width="9%">Submitted To</th>
                          <th width="15%">Clearinghouse Status</th>                                                  
                          <th width="7%">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan="9">
                            <div className="familydl text-center no-record">No record found.</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  }                 
                  {this.props.oaandpayerResponseClaim.data && this.props.oaandpayerResponseClaim.meta && this.props.oaandpayerResponseClaim.meta['totalPages'] && this.props.oaandpayerResponseClaim.meta['totalPages'] > 1 ?
                  <PaginatorCustom data={this.props.oaandpayerResponseClaim.meta} handlePageChange={(pageNumber) => this.loadData(pageNumber)} />
                  : null}
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>

    );
  }
};
OAandPayerResponse = reduxForm({
  form: 'OAandPayerResponseForm',
})(OAandPayerResponse);

function mapStateToProps(state) {
//  console.log('state.billing.master_data............',state.billing)
  let patients = [];
  if (state.billing.patientList && state.billing.patientList.data) {
    patients = state.billing.patientList.data.patients;
  }
  let masterInsurances = [], masterServiceCode = [];
  let masterTagsForAll = [], masterRenderingProviderIncludingInactive = [];
  let masterLocation = [],  masterPatientLocation = [];
  if (state.billing.claimMasterData) {
    masterInsurances = state.billing.claimMasterData.insuranceCompanies || [];        
    masterServiceCode = state.billing.claimMasterData.masterServiceCode || [];
    masterTagsForAll = state.billing.claimMasterData.masterTagsforAll || [];
    masterRenderingProviderIncludingInactive = state.billing.claimMasterData.masterRenderingProviderIncludingInactive || [];
    masterLocation = state.billing.claimMasterData.masterLocation || [];
    masterPatientLocation = state.billing.claimMasterData.masterPatientLocation || [];
  }
  return {
    masterInsurances: masterInsurances,
    masterTagsForAll: masterTagsForAll,        
    masterServiceCode: masterServiceCode,
    masterRenderingProviderIncludingInactive: masterRenderingProviderIncludingInactive,
    oaandpayerResponseClaim: state.billing.oaandpayerResponseClaim,
    loginUserInfo: state.login.loginUserInfo,
    patientlist: patients,    
    edi837ForSecondary: state.billing.edi837ForSecondary,
    masterLocation: masterLocation,
    masterPatientLocation: masterPatientLocation,
    masterClaimOfficeallyStatus: (state.billing.claimMasterData && state.billing.claimMasterData.claimOfficeallyStatus) || [],
    resubmitBatchClaim: state.billing.resubmitBatchClaim,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}

export default connect(mapStateToProps, { getClaimMasterData, getOAandPayerResponseClaims, getPatient, updateClaimServiceLineDetails, updateClaimServiceLineModifier })(OAandPayerResponse);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/OAandPayerResponse.js